import i18next from "i18next";
import { EPeriodTypes } from "./exception.types";

export const renderPeriodFormByType = (type: EPeriodTypes): string => {
  switch (type) {
    case EPeriodTypes.DATE:
      return `
            <div class="col col-fixed">
              <div class="row">${i18next.t($ => $.scheduleBacnet.dayOfWeek)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.dayOfMonth)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.month)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.year)}:</div>
            </div>
            <div class="col col-flexible">
              <div class="row" id="dayOfWeekContainer"></div>
              <div class="row" id="dayOfMonthContainer"></div>
              <div class="row" id="monthContainer"></div>
              <div class="row" id="yearContainer"></div>
            </div>
          `;

    case EPeriodTypes.DATE_RANGE:
      return `
            <div class="col col-fixed">
              <div class="row"></div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.dayOfWeek)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.dayOfMonth)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.month)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.year)}:</div>
            </div>
            <div class="col col-flexible">
              <div class="row">${i18next.t($ => $.scheduleBacnet.start)}:</div>
              <div class="row" id="startDayOfWeekContainer"></div>
              <div class="row" id="startDayOfMonthContainer"></div>
              <div class="row" id="startMonthContainer"></div>
              <div class="row" id="startYearContainer"></div>
            </div>
            <div class="col col-flexible">
              <div class="row">${i18next.t($ => $.scheduleBacnet.end)}:</div>
              <div class="row" id="endDayOfWeekContainer"></div>
              <div class="row" id="endDayOfMonthContainer"></div>
              <div class="row" id="endMonthContainer"></div>
              <div class="row" id="endYearContainer"></div>
            </div>
          `;

    case EPeriodTypes.WEEK_AND_DAY:
      return `
            <div class="col col-fixed">
              <div class="row">${i18next.t($ => $.scheduleBacnet.dayOfWeek)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.week)}:</div>
              <div class="row">${i18next.t($ => $.scheduleBacnet.month)}:</div>
            </div>
            <div class="col col-flexible">
              <div class="row" id="periodDayOfWeekContainer"></div>
              <div class="row" id="periodWeekContainer"></div>
              <div class="row" id="periodMonthContainer"></div>
            </div>
          `;

    case EPeriodTypes.CAL_REF:
      return `
            <div class="col col-fixed">
              <div class="row">${i18next.t($ => $.scheduleBacnet.calendarID)}:</div>
            </div>
            <div class="col col-flexible">
              <div class="row" id="calendarIdContainer"></div>
            </div>
          `;

    default:
      throw new Error("Неизвестный тип формы");
  }
};
